import { render, staticRenderFns } from "./ContratoInvalido.vue?vue&type=template&id=b3bb68d2&"
import script from "./ContratoInvalido.vue?vue&type=script&lang=js&"
export * from "./ContratoInvalido.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ContratoInvalido.vue"
export default component.exports